<template>
    <div class="ec-novidades">
        <!-- botão da barra superior: abre a janela de novidades -->
        <button type="button" class="ec-novidades-botao" :class="{ 'ec-novidades-botao--pendente': temPendentes }"
            title="O que há de novo" aria-label="O que há de novo" @click="abrirJanela()">
            <i class="fa-solid fa-wand-magic-sparkles"></i>
            <span class="ec-novidades-botao__texto">Novidades</span>
        </button>

        <!-- camadas fixas: movidas para o <body> no mounted (a barra superior usa backdrop-filter,
             que prenderia o position:fixed dentro dela) -->
        <div ref="camadas">
            <!-- janela "O que há de novo" -->
            <transition name="ec-novidades-fade">
                <div v-if="janelaAberta" class="ec-novidades-janela" @click.self="fecharJanela()">
                    <div class="ec-novidades-janela__caixa" role="dialog" aria-modal="true" aria-labelledby="ecNovidadesTitulo" tabindex="-1" ref="janela">
                        <button type="button" class="close ec-novidades-janela__fechar" aria-label="Fechar" @click="fecharJanela()"><span aria-hidden="true">&times;</span></button>
                        <div class="ec-novidades-janela__topo">
                            <span class="ec-novidades-janela__selo"><i class="fa-solid fa-wand-magic-sparkles"></i> Novidades</span>
                            <h2 id="ecNovidadesTitulo">O EduConnect CRM está de cara nova</h2>
                            <p>Reformulamos as principais telas para deixar o dia a dia mais rápido e claro. Veja o que mudou:</p>
                        </div>
                        <ul class="ec-novidades-janela__lista">
                            <li v-for="destaque in destaquesVisiveis" :key="destaque.titulo">
                                <span class="ec-novidades-janela__icone"><i :class="destaque.icone"></i></span>
                                <div>
                                    <b>{{ destaque.titulo }}</b>
                                    <small>{{ destaque.texto }}</small>
                                </div>
                            </li>
                        </ul>
                        <div class="ec-novidades-janela__acoes">
                            <button type="button" class="btn btn-outline-primary" @click="fecharJanela()">Agora não</button>
                            <button v-if="toursDaTela.length" type="button" class="btn btn-outline-primary" @click="iniciar(toursDaTela)">
                                <i class="fa-solid fa-location-crosshairs mr-1"></i> Tour desta tela
                            </button>
                            <button type="button" class="btn btn-primary" @click="iniciar([tourGeral].concat(toursDaTela))">
                                <i class="fa-solid fa-play mr-1"></i> Fazer o tour
                            </button>
                        </div>
                    </div>
                </div>
            </transition>

            <!-- aviso discreto: a tela atual tem novidades ainda não vistas -->
            <transition name="ec-novidades-sobe">
                <div v-if="avisoVisivel" class="ec-novidades-aviso" role="status">
                    <i class="fa-solid fa-wand-magic-sparkles"></i>
                    <span>Esta tela tem novidades</span>
                    <button type="button" class="btn btn-sm btn-primary" @click="iniciar(toursPendentes)">Mostrar</button>
                    <button type="button" class="close" aria-label="Dispensar" @click="dispensarAviso()"><span aria-hidden="true">&times;</span></button>
                </div>
            </transition>

            <!-- tour: bloqueio, recorte destacando o alvo e balão -->
            <template v-if="ativo">
                <div class="ec-novidades-bloqueio" @click="proximo()"></div>
                <div class="ec-novidades-recorte" :class="{ 'ec-novidades-recorte--centro': !retangulo }" :style="estiloRecorte"></div>
                <div class="ec-novidades-balao" :class="'ec-novidades-balao--'+lado" :style="estiloBalao" ref="balao"
                    role="dialog" aria-modal="true" aria-labelledby="ecNovidadesPasso" tabindex="-1">
                    <span class="ec-novidades-balao__tour">{{ passoAtual.tour }}</span>
                    <h3 id="ecNovidadesPasso">{{ passoAtual.titulo }}</h3>
                    <p v-html="passoAtual.texto"></p>
                    <div class="ec-novidades-balao__rodape">
                        <span class="ec-novidades-balao__progresso">{{ indice+1 }} de {{ passos.length }}</span>
                        <button type="button" class="btn btn-sm btn-link" @click="encerrar()">Pular</button>
                        <button v-if="indice>0" type="button" class="btn btn-sm btn-outline-primary" @click="anterior()">Voltar</button>
                        <button type="button" class="btn btn-sm btn-primary" @click="proximo()">{{ indice==passos.length-1 ? 'Concluir' : 'Próximo' }}</button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { VERSAO, destaques, tours } from '../novidades'

// largura até onde o menu lateral vira gaveta (media-breakpoint-down(md) do Bootstrap)
const LARGURA_GAVETA = 991.98
const FOLGA = 8
const ESPACO = 14

export default {
    props:{
        // separa o progresso de cada usuário no mesmo navegador
        usuario:{
            type:[String, Number],
            default:''
        }
    },
    data(){
        return{
            estado:{ versao:VERSAO, boasVindas:false, vistos:[] },
            janelaAberta:false,
            avisoVisivel:false,
            toursDaTela:[],
            ativo:false,
            toursEmAndamento:[],
            passos:[],
            indice:0,
            retangulo:null,
            lado:'baixo',
            posicaoBalao:{ top:0, left:0 },
            abriuMenu:false,
            quadro:null
        }
    },
    computed:{
        chave(){
            return 'ec-novidades:'+this.usuario
        },
        tourGeral(){
            return tours.find(tour => tour.id=='geral')
        },
        destaquesVisiveis(){
            return destaques.filter(destaque => !destaque.visivel || destaque.visivel())
        },
        toursPendentes(){
            return this.toursDaTela.filter(tour => !this.estado.vistos.includes(tour.id))
        },
        temPendentes(){
            return !this.estado.boasVindas || this.toursPendentes.length>0
        },
        passoAtual(){
            return this.passos[this.indice] || {}
        },
        estiloRecorte(){
            if(!this.retangulo){
                return {}
            }
            return {
                top: (this.retangulo.top-FOLGA)+'px',
                left: (this.retangulo.left-FOLGA)+'px',
                width: (this.retangulo.width+FOLGA*2)+'px',
                height: (this.retangulo.height+FOLGA*2)+'px'
            }
        },
        estiloBalao(){
            return { top:this.posicaoBalao.top+'px', left:this.posicaoBalao.left+'px' }
        }
    },
    mounted(){
        document.body.appendChild(this.$refs.camadas)
        this.carregarEstado()
        window.addEventListener('keydown', this.teclado)
        window.addEventListener('resize', this.agendarPosicao)
        window.addEventListener('scroll', this.agendarPosicao, true)

        // os componentes das telas carregam dados depois do mount: espera antes de procurar os alvos
        setTimeout(() => {
            this.toursDaTela = this.identificarTours()
            if(!this.estado.boasVindas){
                this.abrirJanela()
            }else if(this.toursPendentes.length){
                this.avisoVisivel = true
            }
        }, 1200)
    },
    beforeDestroy(){
        window.removeEventListener('keydown', this.teclado)
        window.removeEventListener('resize', this.agendarPosicao)
        window.removeEventListener('scroll', this.agendarPosicao, true)
        this.$refs.camadas.remove()
    },
    methods:{
        carregarEstado(){
            try{
                const salvo = JSON.parse(localStorage.getItem(this.chave) || 'null')
                if(salvo && salvo.versao==VERSAO){
                    this.estado = Object.assign({ boasVindas:false, vistos:[] }, salvo)
                }
            }catch(e){
                // sem localStorage (janela anônima, site bloqueado): o tour funciona, só não lembra o progresso
            }
        },
        salvarEstado(){
            try{
                localStorage.setItem(this.chave, JSON.stringify(this.estado))
            }catch(e){}
        },
        marcarVistos(ids){
            this.estado.vistos = Array.from(new Set(this.estado.vistos.concat(ids)))
            this.salvarEstado()
        },
        identificarTours(){
            const caminho = window.location.pathname
            return tours.filter(tour => tour.id!='geral'
                && (!tour.pagina || tour.pagina.test(caminho))
                && (!tour.presente || document.querySelector(tour.presente)))
        },
        abrirJanela(){
            this.toursDaTela = this.identificarTours()
            this.avisoVisivel = false
            this.janelaAberta = true
            this.$nextTick(() => this.$refs.janela && this.$refs.janela.focus())
        },
        fecharJanela(){
            this.janelaAberta = false
            this.estado.boasVindas = true
            this.salvarEstado()
        },
        dispensarAviso(){
            this.avisoVisivel = false
            this.marcarVistos(this.toursPendentes.map(tour => tour.id))
        },

        // ---- tour --------------------------------------------------------
        iniciar(lista){
            this.janelaAberta = false
            this.avisoVisivel = false
            this.estado.boasVindas = true
            this.salvarEstado()

            this.toursEmAndamento = lista
            this.passos = []
            lista.forEach(tour => {
                tour.passos.forEach(passo => this.passos.push(Object.assign({ tour:tour.titulo }, passo)))
            })
            // mantém só os passos com alvo visível agora (o do menu conta mesmo com a gaveta fechada)
            this.passos = this.passos.filter(passo => !passo.alvo || this.elementoDoPasso(passo))
            if(!this.passos.length){
                return
            }
            this.ativo = true
            this.mostrar(0)
        },
        elementoDoPasso(passo){
            const elementos = Array.from(document.querySelectorAll(passo.alvo))
            return elementos.find(el => el.getClientRects().length && el.offsetWidth+el.offsetHeight>0) || null
        },
        mostrar(indice){
            this.indice = indice
            const passo = this.passos[indice]
            this.ajustarMenu(!!passo.menu)

            const el = passo.alvo ? this.elementoDoPasso(passo) : null
            if(!el){
                this.retangulo = null
                this.$nextTick(this.posicionar)
                return
            }
            const r = el.getBoundingClientRect()
            const topoFixo = (document.querySelector('.ec-topo') || {}).offsetHeight || 0
            if(!passo.menu && (r.top<topoFixo+FOLGA || r.bottom>window.innerHeight-FOLGA)){
                el.scrollIntoView({ block: r.height>window.innerHeight*.6 ? 'start' : 'center', behavior:'smooth' })
            }
            // a gaveta do menu e a rolagem suave levam um instante para assentar
            this.posicionar()
            setTimeout(this.posicionar, 350)
            this.$nextTick(() => this.$refs.balao && this.$refs.balao.focus({ preventScroll:true }))
        },
        ajustarMenu(precisa){
            const gaveta = window.innerWidth<=LARGURA_GAVETA
            if(precisa && gaveta && !document.body.classList.contains('ec-menu-aberto')){
                document.body.classList.add('ec-menu-aberto')
                this.abriuMenu = true
            }else if(!precisa && this.abriuMenu){
                document.body.classList.remove('ec-menu-aberto')
                this.abriuMenu = false
            }
        },
        agendarPosicao(){
            if(!this.ativo || this.quadro){
                return
            }
            this.quadro = requestAnimationFrame(() => {
                this.quadro = null
                this.posicionar()
            })
        },
        posicionar(){
            if(!this.ativo){
                return
            }
            const passo = this.passoAtual
            const el = passo.alvo ? this.elementoDoPasso(passo) : null
            const larguraTela = window.innerWidth
            const alturaTela = window.innerHeight

            if(el){
                const r = el.getBoundingClientRect()
                // limita o recorte à área visível (alvos maiores que a tela, como o menu lateral)
                const top = Math.max(r.top, FOLGA)
                const bottom = Math.min(r.bottom, alturaTela-FOLGA)
                this.retangulo = { top, left:r.left, width:r.width, height:Math.max(bottom-top, 0) }
            }else{
                this.retangulo = null
            }

            this.$nextTick(() => {
                const balao = this.$refs.balao
                if(!balao){
                    return
                }
                const largura = balao.offsetWidth
                const altura = balao.offsetHeight
                const ret = this.retangulo
                let lado = 'centro', top = (alturaTela-altura)/2, left = (larguraTela-largura)/2

                if(ret){
                    const abaixo = alturaTela-(ret.top+ret.height)-FOLGA
                    const acima = ret.top-FOLGA
                    const direita = larguraTela-(ret.left+ret.width)-FOLGA
                    if(direita>=largura+ESPACO*2 && ret.height>alturaTela*.5){
                        lado = 'direita'
                        left = ret.left+ret.width+FOLGA+ESPACO
                        top = ret.top+Math.min(ret.height/2, 160)-altura/2
                    }else if(abaixo>=altura+ESPACO*2){
                        lado = 'baixo'
                        top = ret.top+ret.height+FOLGA+ESPACO
                        left = ret.left+ret.width/2-largura/2
                    }else if(acima>=altura+ESPACO*2){
                        lado = 'cima'
                        top = ret.top-FOLGA-ESPACO-altura
                        left = ret.left+ret.width/2-largura/2
                    }else{
                        // sem espaço ao redor (alvo grande ou tela pequena): balão no rodapé da tela
                        lado = 'rodape'
                        top = alturaTela-altura-ESPACO
                        left = (larguraTela-largura)/2
                    }
                }
                this.lado = lado
                this.posicaoBalao = {
                    top: Math.round(Math.min(Math.max(top, ESPACO), alturaTela-altura-ESPACO)),
                    left: Math.round(Math.min(Math.max(left, ESPACO), larguraTela-largura-ESPACO))
                }
            })
        },
        proximo(){
            if(this.indice<this.passos.length-1){
                this.mostrar(this.indice+1)
            }else{
                this.encerrar()
            }
        },
        anterior(){
            if(this.indice>0){
                this.mostrar(this.indice-1)
            }
        },
        encerrar(){
            this.ativo = false
            this.ajustarMenu(false)
            this.marcarVistos(this.toursEmAndamento.map(tour => tour.id))
            this.passos = []
            this.retangulo = null
        },
        teclado(evento){
            if(this.janelaAberta && evento.key=='Escape'){
                this.fecharJanela()
                return
            }
            if(!this.ativo){
                return
            }
            if(evento.key=='Escape'){
                this.encerrar()
            }else if(evento.key=='ArrowRight'){
                this.proximo()
            }else if(evento.key=='ArrowLeft'){
                this.anterior()
            }
        }
    }
}
</script>
